var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('leaflet-map-selection',{attrs:{"map":_vm.map,"leaflet":_vm.leaflet,"geoJsonGeometry":_vm.geoJsonGeometry}})}
var staticRenderFns = []

export { render, staticRenderFns }